export default __webpack_public_path__ + "static/media/product_01.1.2244bc02.jpg";